import React from "react";
import {ManageUser} from "../ManageUsers/ManageUsers";
import {ManageUserDental} from "../ManageUsers/ManageUsersDental";
import {ManageUserSicor} from "../ManageUsers/ManageUsersSicor";
import {getCommercialPromoters} from "./CommercialPromoterAction";
import {connect} from "react-redux";
import {getRoleForm, hasRole} from "../../../auth/util";
import {openDialogAction} from "../../comun/DialogManager/DialogManagerAction";
import {AssignTeamLeader} from "./AssignTeamLeader/AssignTeamLeader";


export let ManageCommercialPromoter = ({dialogData, onDialogOpen, user, ...props}) => {
    const loadFilter = {};
    if (!hasRole(user, 'ADMINISTRATOR')) {
        loadFilter[getRoleForm(user)] = user.id;
    }
    const assignText = "Asignar";
    const assignAction = (userAction, callback) => {
        onDialogOpen({
            component: AssignTeamLeader, data: {parent: userAction.parent, user:userAction},
            opened: true, id: "assign-user-dialog", onClose: () => {
                callback();
            }
        });
    }
    
    if (user.campaign.name === "Vivanta" || user.campaign.name === "Vitaldent" ||user.campaign.name === "KonectaDental" ){
		  return (
		    
	        <ManageUserDental title="Gestionar Promotores comerciales" assignText={assignText} assignAction={assignAction}
	                    loadFilter={loadFilter} action={getCommercialPromoters} assignStand={true} />
	    )
    }else if(user.campaign.name === "Sicor"){
        return (
		    
	        <ManageUserSicor title="Gestionar Promotores comerciales" assignText={assignText} assignAction={assignAction}
	                    loadFilter={loadFilter} action={getCommercialPromoters} assignStand={true} />
	    )
        
    }else{
	  return (
	    
        <ManageUser title="Gestionar Promotores comerciales" assignText={assignText} assignAction={assignAction}
                    loadFilter={loadFilter} action={getCommercialPromoters} assignStand={true} rol = "Promotor" />
      )
    }
    
}


const mapDispatchToProps = dispatch => {
    return {
        onDialogOpen: data => {
            dispatch(openDialogAction(data));
        },
    }
}


const mapStateToProps = (state) => {
    return {user: state.user};
}
ManageCommercialPromoter = connect(mapStateToProps, mapDispatchToProps)(ManageCommercialPromoter);


